interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDangerous?: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  title,
  message,
  confirmBtnText = "Confirm",
  cancelBtnText = "Cancel",
  onConfirm,
  onCancel,
  isDangerous = false,
}: ConfirmationModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              {cancelBtnText}
            </button>
            <button
              type="button"
              className={`btn ${isDangerous ? "btn-danger" : "btn-primary"}`}
              onClick={onConfirm}
            >
              {confirmBtnText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
